import { UnorderedList, ListItem, Text } from '@chakra-ui/react';
import { RequirementsSummary } from 'shared-components';

interface IProps {
  uploadComplete: boolean;
  highlightedSections: string[];
}

export default function Requirements(props: IProps) {
  const allSections = ['1.1', '2.1', '2.2', '2.3', '2.4', '2.5'];
  const sectionsToShow =
    props.highlightedSections && props.highlightedSections.length ? props.highlightedSections : allSections;

  return (
    <>
      {sectionsToShow.join('').indexOf('1.') !== -1 ? (
        <RequirementsSummary
          title={'1. We have to be sure your document is authentic'}
          uploadWarning={props.uploadComplete}
        >
          {sectionsToShow.includes('1.1') ? (
            <UnorderedList>
              {sectionsToShow.includes('1.1') ? (
                <ListItem>You must upload a scan of the original document</ListItem>
              ) : null}
            </UnorderedList>
          ) : null}
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('2.') !== -1 ? (
        <RequirementsSummary
          title={'2. Certificate must be in English or have an English translation'}
          uploadWarning={props.uploadComplete}
        >
          {sectionsToShow.includes('2.1') ? (
            <>
              <Text mt={4} mb={2}>
                For certificates in English:
              </Text>

              <UnorderedList>
                <ListItem>Nothing further required</ListItem>
              </UnorderedList>
            </>
          ) : null}

          {sectionsToShow.includes('2.2') ||
          sectionsToShow.includes('2.3') ||
          sectionsToShow.includes('2.4') ||
          sectionsToShow.includes('2.5') ? (
            <>
              <Text mt={4} mb={2}>
                For certificates not in English:
              </Text>

              <UnorderedList>
                {sectionsToShow.includes('2.2') ? (
                  <ListItem>A translation must be included with the certificate</ListItem>
                ) : null}
                {sectionsToShow.includes('2.3') ? (
                  <ListItem>The translation must be signed and dated by a qualified translator</ListItem>
                ) : null}
                {sectionsToShow.includes('2.4') ? (
                  <ListItem>
                    The translator must confirm the document is an accurate translation of the original
                  </ListItem>
                ) : null}
                {sectionsToShow.includes('2.5') ? (
                  <ListItem>Contact details and credentials for the translator must be included</ListItem>
                ) : null}
              </UnorderedList>
            </>
          ) : null}
        </RequirementsSummary>
      ) : null}
    </>
  );
}
